export const FLOW_TEST_EMAIL = 'fundraisingschoolfornonprofits@gmail.com';
export const isFlowTestEmail = (value) => String(value || '').trim().toLowerCase() === FLOW_TEST_EMAIL;
